import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLoggedIn = authService.isLoggedIn();
  const isLoginPage = state.url === '/login';

  if (!isLoggedIn && !isLoginPage) {
    return router.parseUrl('/login');
  }

  if (isLoggedIn && isLoginPage) {
    const home = authService.mustChangePassword() ? '/change-password' : authService.homeRoute();
    return router.parseUrl(home);
  }

  return true;
};
